import React from "react";
import "./varniConfirmReceiptNeeded.css";
import { useNavigate } from "react-router-dom";

export default function VarniConfirmReceiptNeeded() {

    const navigate = useNavigate();

    const onYesClicked = (): void => { 
        navigate("/varni-acquire-donor-details");
    }

    const onNoClicked = (): void => { 
        navigate("/varni-pay");
    }

    return (<div className="varni-confirm-receipt-needed">
        
            <div>
                <div>
                    <span className="questionText">Would you like a receipt for your donation?</span>
                </div>
            </div>
            <div>
                <RenderChoice onSelected={onYesClicked} text="Yes" />
                <RenderChoice onSelected={onNoClicked} text="No" />
            </div>
        
    </div>);
}

interface ChoiceProps {
    text: string;
    onSelected: () => void
}

function RenderChoice(props: ChoiceProps) {
    return (<div className="varni-render-choice">
        <div className={"color-yb bubble center-text"} onClick={() => props.onSelected()}>
            <div className="amountText">{props.text}</div>
        </div>
    </div>)
}